<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i>
        <strong>Liste des statuts</strong>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col sm="4">
            <b-form-group label-for="basicSelect">
              <label for="categorie"><strong>Catégorie</strong></label>
              <b-form-select
                id="basicSelect"
                :plain="true"
                :options="categoryOptions"
                v-model="selectedCategory"
                @change="search(selectedCategory)"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <v-client-table :columns="columns" :data="items" :options="options">
          <div slot="action" slot-scope="props">
            <b-button
              type="button"
              @click.prevent="destroy(props.row.id)"
              class="badge badge-danger mr-3 p-2"
            >
              <i class="fa fa-trash"></i>
            </b-button>
            <b-button
              type="button"
              @click="editStatus('edit', props.row.id)"
              class="badge badge-primary p-2"
            >
              <i class="fa fa-edit"></i>
            </b-button>
          </div>
          <div v-if="props.row.parent_id" slot="parent_id" slot-scope="props">
            <span class="badge badge-success p-2">{{ getLibelleParent(props.row.parent_id) }}</span>
          </div>
        </v-client-table>
      </b-card-body>
      <div slot="footer">
        <b-button
          type="button"
          @click="editStatus('add')"
          class="pull-right"
          size="md"
          variant="primary"
        >
          <i class="fa fa-plus"></i> Ajouter un statut
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../../utils/auth'

export default {
  data() {
    return {
      columns: ['id','libelle_front', 'libelle_bo', 'libelle_technique','parent_id','critere_priorite','libelle_destinataire_ps','traitement_ps.libelle', 'action'],
      items: [],
      options: {
        headings: {
          libelle_front: 'Libellé client',
          libelle_bo: 'Libellé gestionnaire',
          libelle_technique: 'Libellé technique',
          parent_id: 'Parent',
          critere_priorite: 'Critère priorité',
          libelle_destinataire_ps: 'Libellé destinataire',
          'traitement_ps.libelle': 'Traitement secondaire',
          action: 'Action'
        },
        sortable: ['libelle_front', 'libelle_bo'],
        filterable: ['libelle_front', 'libelle_bo'],
        perPage: 10,
        perPageValues: [10, 25, 50],
        texts: {
          filterPlaceholder: 'Libellé client, Libellé gestionnaire'
        },
        // orderBy: { column: 'created_at', ascending: false }
      },
      categoryOptions: [],
      selectedCategory: '',
    }
  },
  mounted() {
    this.allCategory()
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json'
    this.$axios.defaults.headers.common['Provider'] = getProvider()

    if (this.$route.query.category) {
      this.selectedCategory = this.$route.query.category
      this.search(this.selectedCategory)
    }
  },
  methods: {
    allCategory() {
      let self = this
      this.$store.commit('IS_LOADING', true)
      this.$axios
        .get('/administration/categories')
        .then(response => {
          this.$store.commit('IS_LOADING', false)

          let categories = response.data.categories
          for (var i = 0; i < categories.length; i++) {
            this.categoryOptions.push({
              text: categories[i].libelle,
              value: categories[i].id
            })
          }
        })
        .catch(function(error) {
          self.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI.',
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    search(categoryId) {
      let self = this
      this.$store.commit('IS_LOADING', true)
      this.$axios
        .get('/administration/statuts/' + categoryId)
        .then(response => {
          this.$store.commit('IS_LOADING', false)
          this.items = response.data.status
        })
        .catch(function(error) {
          self.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI.',
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    getLibelleParent(parentId) {
      if (parentId) {
        for (let status of this.items) {
          if(status.id === parentId) { return status.libelle_bo }
        }
      }
      return '-'
    },
    editStatus(to, id) {
      if (to === "edit") {
        this.$router.push({ path: '/administration/statuts/edit/' + id, query: { category: this.selectedCategory }})
      } else if (to === 'add') {
        this.$router.push({ path: '/administration/statuts/add' });
      }
    },
    destroy(id) {
      let self = this
      this.$swal.fire({
        title: 'Êtes-vous sûr?',
        text: 'Voulez-vous vraiment supprimer ce statut ?',
        type: 'warning',
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonColor:"#ff1744",
        confirmButtonText: 'Annuler',
        cancelButtonText: 'Supprimer',
      }).then((result) => {
        if (result.value !== true) {
          this.$store.commit('IS_LOADING', true)
          this.$axios
            .post("/administration/statuts/delete/" + id)
            .then(response => {
              this.$store.commit('IS_LOADING', false)
              this.$swal({ position: 'top', type: 'success', title:'Suppression avec succès', text:'Le statut a bien été supprimé',showConfirmButton: false, timer: 5000})
              // on ré-actualise les status par catégorie et on relance l'affichage de la catégorie sélectionnée
              this.allCategory()
              this.search(this.selectedCategory)
            })
            .catch(function(error){
              self.$store.commit('IS_LOADING', false)
              self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue lors de la suppression du statut. Si le problème persiste, merci de faire un ticket au support DOSI.',showConfirmButton: false, timer: 5000})
            })
        }
      })
    },
    formatDate(textDate) {
      let date =
        textDate !== null
          ? new Date(textDate).toLocaleDateString("fr-FR")
          : "-";
      return date;
    }
  }
}
</script>

<style>

</style>
